<template>
  <IDEDialog
    title="上传代码包"
    width="400px"
    :visible="visible"
    :withFooter="false"
    :dialog-class="{ 'upload-zip-dialog': true }"
    @close="close"
  >
    <el-upload
      action="/api/template/upload/zip"
      :show-file-list="false"
      :drag="true"
      accept=".zip"
      :with-credentials="true"
      :on-success="uploadSuccess"
    >
      <p>拖拽.zip文件到此或点击选择</p>
    </el-upload>
  </IDEDialog>
</template>

<script>
import IDEDialog from '../IDEDialog'
import InputItem from './InputItem'
import { buildNewFile } from '../utils'
import Constants from '../constants'

export default {
  name: 'UploadZipDialog',
  components: { InputItem, IDEDialog },
  props: {
    // 模版ID
    templateId: {}
  },
  data () {
    return {
      visible: false
    }
  },
  methods: {
    // 打开窗口
    open () {
      this.visible = true
    },
    // 关闭窗口
    close () {
      this.visible = false
    },
    // 上传成功
    uploadSuccess (response) {
      if (!response.success) {
        this.$tip.apiFailed(response)
        return
      }
      this.close()
      this.$emit('upload-success', response.data.map(file => {
        file.outputPath = Constants.PROJECT_NAME + '/' + file.outputPath
        file.__isEdited = true
        return buildNewFile(file)
      }))
    }
  }
}
</script>

<style lang="scss">
@import "../variables";
.upload-zip-dialog {
  .el-dialog__body {
    padding: 10px 0 20px 0 !important;
  }
  .el-upload-dragger {
    background-color: $code-space-background;
    border: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
